import React from 'react'

function Summery({ color = '#252C32', bgColor = 'white' }) {
    return (
        <>
            <svg width="24" height="24" viewBox="0 0 16 17" fill={bgColor} xmlns="http://www.w3.org/2000/svg">
                <path d="M14.0002 1.83398H2.00016C1.63198 1.83398 1.3335 2.13246 1.3335 2.50065V3.83398C1.3335 4.20217 1.63198 4.50065 2.00016 4.50065H14.0002C14.3684 4.50065 14.6668 4.20217 14.6668 3.83398V2.50065C14.6668 2.13246 14.3684 1.83398 14.0002 1.83398Z" stroke={color} stroke-linecap="round" />
                <path d="M14.0002 7.16602H2.00016C1.63198 7.16602 1.3335 7.46448 1.3335 7.83268V9.16602C1.3335 9.53422 1.63198 9.83268 2.00016 9.83268H14.0002C14.3684 9.83268 14.6668 9.53422 14.6668 9.16602V7.83268C14.6668 7.46448 14.3684 7.16602 14.0002 7.16602Z" stroke={color} stroke-linecap="round" />
                <path d="M14.0002 12.5H2.00016C1.63198 12.5 1.3335 12.7985 1.3335 13.1667V14.5C1.3335 14.8682 1.63198 15.1667 2.00016 15.1667H14.0002C14.3684 15.1667 14.6668 14.8682 14.6668 14.5V13.1667C14.6668 12.7985 14.3684 12.5 14.0002 12.5Z" stroke={color} stroke-linecap="round" />
            </svg>

        </>
    )
}

export default Summery